import React from "react";
import Districts from "../../containers/district";
import { Layout } from "antd";
import "./styles.css";
// import Navbar from '../../components/navbar';
const { Footer, Content } = Layout;

function index(props) {
  return (
    <div>
      <Layout>
        <Content>
          <Districts props={props} />
        </Content>
        <Footer>Footer</Footer>
      </Layout>
    </div>
  );
}

export default index;
